import React from 'react';

import { MessageBlock } from '@getro/rombo';

const NoAccess = () => (
  <MessageBlock
    type="warning"
    title="Adding companies unavailable"
    content="Only network admins can see this screen."
  />
);

export default NoAccess;
